import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectDreamTeamCardData_MLB, selectSelectedCardId } from '../../../../store/showcase/showcase.selector';
import { setNewSelectionCardData, setPreselectedCardId, setPreselectedCardType } from '../../../../store/showcase/showcase.action';

// styles
import {
    ShowcaseDisplayContainer,
    MainTitleContainer,
    HeaderActions,
    ViewToggle,
    ViewToggleButton,
    ContentContainer,
} from './ShowcaseDisplay.styles';

// components
import BullpenDisplay from '../bullpen-display/BullpenDisplay';
import FieldDisplay from '../field-display/FieldDisplay';
import ShowcaseCarousel from '../showcase-carousel/ShowcaseCarousel';
import ShowcaseSelectionView from '../card-selection-view/CardSelectionView';
import Title from '../../../../components/widgets/components/title/Title';

export default function ShowcaseDisplay() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const selectedCardId = useSelector(selectSelectedCardId);
    const dreamTeamCardData_MLB = useSelector(selectDreamTeamCardData_MLB);
    const [view, setView] = useState(location.state?.showcaseView === 'field' ? 'field' : 'carousel');

    const showView = (nextView) => {
        if (view === 'field' && nextView === 'carousel') {
            dispatch(setPreselectedCardId(null));
            dispatch(setPreselectedCardType(null));
        }
        setView(nextView);
        navigate('/', { replace: true, state: { showcaseView: nextView } });
    };

    useEffect(() => {
        const newSelectionCardData = {
            name: [],
            cardPath: [],
            cardParallel: {
                cardColor: '',
                cardParallelName: '',
                cardPrintNumber: null,
                cardSupply: 0,
            }
        };
        dispatch(setNewSelectionCardData(newSelectionCardData));
    }, [dispatch])

    return (
        <ShowcaseDisplayContainer>
            <MainTitleContainer>
                <Title text="SHOWCASE" alignItems="center"/>
                <HeaderActions>
                    <ViewToggle role="group" aria-label="Showcase view">
                        <ViewToggleButton
                            type="button"
                            $active={view === 'carousel'}
                            aria-pressed={view === 'carousel'}
                            onClick={() => showView('carousel')}
                        >
                            Cards
                        </ViewToggleButton>
                        <ViewToggleButton
                            type="button"
                            $active={view === 'field'}
                            aria-pressed={view === 'field'}
                            onClick={() => showView('field')}
                        >
                            Field
                        </ViewToggleButton>
                    </ViewToggle>
                </HeaderActions>
            </MainTitleContainer>
            <ContentContainer $view={view}>
                {selectedCardId === null ?
                    view === 'field' ?
                        <>
                            <FieldDisplay />
                            <BullpenDisplay />
                        </>
                        :
                        <ShowcaseCarousel />
                    :
                    <ShowcaseSelectionView cardData={dreamTeamCardData_MLB[selectedCardId]} />
                }
            </ContentContainer>
        </ShowcaseDisplayContainer>
    )
}
